import { InvoicesDetail } from '../../../models/reports/admin-report/invoices-detail.model';
import {AbstractReportAdminPmsApiService} from "../abstract-report-admin.service";

/**
 * @class InvoicesDetailPmsApiService
 * @abstract
 * @extends {AbstractReportAdminPmsApiService<InvoicesDetail>}
 */
export class InvoicesDetailPmsApiService extends AbstractReportAdminPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/admin-reports/invoices-detail';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {InvoicesDetail}
     * @protected
     */
    newModel(attributes, ...params) {

        return new InvoicesDetail(attributes);
    }
}



// WEBPACK FOOTER //
// ./src/pms-api/services/reports/admin-report/invoices-details.service.js